// Metronome engines announce start, real bar downbeats and stop here (drone chord changes),
// plus every scheduled click so the pitch detector can ignore it.
const starts = new Set();
const bars = new Set();
const stops = new Set();
const clicks = new Set();

export const transportBus = {
  onStart(fn) { starts.add(fn); return () => starts.delete(fn); },
  emitStart(id) { starts.forEach((fn) => fn(id)); },
  onBar(fn) { bars.add(fn); return () => bars.delete(fn); },
  emitBar(info = { id: null, lead: 0, latency: 0 }) { bars.forEach((fn) => fn(info)); },
  onStop(fn) { stops.add(fn); return () => stops.delete(fn); },
  emitStop(id) { stops.forEach((fn) => fn(id)); },
  onClick(fn) { clicks.add(fn); return () => clicks.delete(fn); },
  emitClick(lead) { clicks.forEach((fn) => fn(lead)); },
};
